import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FuseConfirmDialogModule } from '@fuse/components';
import { ReportFormDialogComponent } from './report-form/report-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReportsService } from './reports.service'
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';



@NgModule({
  declarations: 
    [
        ReportsComponent,
        ReportFormDialogComponent
    ],

    imports: [
        CommonModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatIconModule,
        MatSelectModule,
        MatInputModule,
        MatMenuModule,
        MatToolbarModule,
        MatSnackBarModule,
        MatTooltipModule,

        FuseConfirmDialogModule,
        FuseSharedModule,
        MatDialogModule,
        MatCheckboxModule
    ],
    providers: [
        ReportsService
    ],
    exports:[
        ReportsComponent
    ]
})
export class ReportsModule { }
